import CustomTabs from "../../common/custom-tabs";
import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Snackbar,
  Alert,
  CssBaseline,
  ThemeProvider,
  createTheme,
} from "@mui/material";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import GridViewOutlinedIcon from "@mui/icons-material/GridViewOutlined";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";

import KalanjayDashboard from "./pages/KalanjayDashboard";
import KalanjayBatches from "./pages/KalanjayBatches";
import KalanjayBatchDetail from "./pages/KalanjayBatchDetail";
import KalanjayWaitlist from "./pages/KalanjayWaitlist";

import SidebarButton from "../../common/SidebarButton";
import typography from "../../cssUtils/typography";

import axios from "axios";
import { GET_KALANJAY_WAITLIST } from "../../config/urls";
import { useAuth } from "../../hooks/AuthProvider";
import KalanjayAgeGroups from "./pages/KalanjayAgeGroups";
import KalanjayBatchCollection from "./pages/KalanjayBatchCollection";

// ── MUI theme override (Lexend font) ─────────────────────────────────────────
const theme = createTheme({
  typography: {
    fontFamily: `'Lexend', 'Roboto', 'Helvetica', 'Arial', sans-serif`,
  },
  components: {
    MuiButton: { defaultProps: { disableElevation: true } },
    MuiTextField: { defaultProps: { size: "small" } },
  },
});

// ══════════════════════════════════════════════════════════════════════════════
export default function Kalanjay() {
  const [selectedBatch, setSelectedBatch] = useState(null);
  const [fees, setFees] = useState([]);
  const [exams, setExams] = useState([]);
  const [batches, setBatches] = useState([]);
  const [selectedAgeGroup, setSelectedAgeGroup] = useState(null);
  const [selectedAgeGroupName, setSelectedAgeGroupName] = useState(null);
  const [selectedCentreId, setSelectedCentreId] = useState(null);
  const [waitlist, setWaitlist] = useState([]);
  const [toast, setToast] = useState({ open: false, msg: "" });
  const [activeTab, setActiveTab] = useState("batches");
  const showToast = (msg) => setToast({ open: true, msg });
  const closeToast = () => setToast((p) => ({ ...p, open: false }));
  const [centres, setCentres] = useState([]);
  const permissions = localStorage.getItem("permissions") || [];
  const canViewPaymentReport =
    permissions.includes("payment_report.view") ||
    permissions.includes("payment_report.view_grant_road");
  const TABS = [
    { label: "Batches", value: "batches" },
    { label: "Waitlist", value: "waitlist" },
    ...(canViewPaymentReport ? [{ label: "Payment Report", value: "payment_report" }] : []),
  ];
  const [lastViewedPage, setLastViewedPage] = useState("");

  // Waitlist Pagination
  const [waitlistPage, setWaitlistPage] = useState(0);
  const [waitlistRowsPerPage, setWaitlistRowsPerPage] = useState(20);
  const [waitlistTotalCount, setWaitlistTotalCount] = useState(0);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box sx={{ minHeight: "100vh", backgroundColor: "#ffffff" }}>
        <Box sx={{ mb: 2,  px: { xs: 2, sm: 3 }, pt: 3, width: "100%", overflowX: "hidden", }}>
          <CustomTabs
            value={activeTab}
            onChange={(e, val) => {
              if (["waitlist", "collection"].includes(val) && selectedBatch) {
                setSelectedBatch(null);
              }
              if (selectedAgeGroup) {
                setSelectedAgeGroup(null);
              }
              if (selectedAgeGroupName) {
                setSelectedAgeGroupName(null);
              }
              setActiveTab(val);
            }}
            tabs={TABS}
            sx={{ mb: 2 }}
          />
        </Box>

        {/* ── Main content ── */}
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            minHeight: "100vh",
            width: "100%",
            overflowX: "hidden",
          }}
        >
          {/* Page content */}
          <Box sx={{ flex: 1, overflowY: "auto", width: "100%", overflowX: "hidden" }}>
            {/* {activeTab === "dashboard" && (
              <KalanjayDashboard
                batches={batches}
                students={students}
                fees={fees}
              />
            )} */}

            {/* {activeTab === "batches" && (
              <KalanjayBatches
                centres={centres}
                batches={batches}
                setBatches={setBatches}
                students={students}
                fees={fees}
                onSelectBatch={async (b) => {
                  await fetchStudents(b.id);   
                  setSelectedBatch(b);
                  setActiveTab("batch");
                }}
                fetchBatches={fetchBatches}

              />
            )} */}

            {activeTab === "batches" &&
              (selectedBatch ? (
                <KalanjayBatchDetail
                  batch={selectedBatch}
                  batches={batches}
                  fees={fees}
                  exams={exams}
                  onBack={() => {
                    setSelectedBatch(null);
                  }}
                  showToast={showToast}
                  lastViewedPage={lastViewedPage}
                  setLastViewedPage={setLastViewedPage}
                  setActiveTab={setActiveTab}

                />
              ) : (
                <KalanjayBatches
                  centres={centres}
                  fees={fees}
                  onSelectBatch={(b) => {
                    setSelectedBatch(b);
                  }}
                />
              ))}
            {activeTab === "waitlist" &&
              (selectedAgeGroup ? (
                <KalanjayWaitlist
                  ageGroup={selectedAgeGroup}
                  ageGroupName={selectedAgeGroupName}
                  defaultCentreId={selectedCentreId}
                  allBatches={batches}
                  showToast={showToast}
                  onBack={() => {
                    setSelectedAgeGroup(null); // ← clears selection, shows list
                    setSelectedAgeGroupName(null);
                  }}
                />
              ) : (
                <KalanjayAgeGroups
                  setSelectedAgeGroup={setSelectedAgeGroup}
                  setSelectedAgeGroupName={setSelectedAgeGroupName}
                  setSelectedCentreId={setSelectedCentreId}
                />
              ))}
            {activeTab === "payment_report" && (
              <KalanjayBatchCollection
                selectedBatch={selectedBatch}
                setSelectedBatch={setSelectedBatch}
                setActiveTab={setActiveTab}
                setLastViewedPage={setLastViewedPage}
              />
            )}
          </Box>
        </Box>
      </Box>

      {/* Toast */}
      <Snackbar
        open={toast.open}
        autoHideDuration={2800}
        onClose={closeToast}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          onClose={closeToast}
          severity="success"
          sx={{ ...typography.bodyLarge, borderRadius: "10px" }}
        >
          {toast.msg}
        </Alert>
      </Snackbar>
    </ThemeProvider>
  );
}
